import api from 'configs/api'
import { VideoRoomSession } from 'types/videoRoomSesssion'

export const fetchRoomToken = async (
  schedulingId: string
): Promise<VideoRoomSession> => {
  const { data } = await api.get<VideoRoomSession>(
    `/video/v4/room/appointment/${schedulingId}/create/token?platform=professional`
  )
  return data
}
